/* ai-mode-button.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ai-mode-button.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import Button from '@atlaskit/button/new';
import { useCloudIdToUrl } from '@atlaskit/linking-common/hooks';
import { Anchor, Box } from '@atlaskit/primitives/compiled';
import { AIModeIcon } from './assets/AIModeIcon';
var styles = {
  aiModePromptLabelStyles: "_11c82smr _k48pi7a9 _19bvv77o _u5f3ze3t"
};
export var AIModeButton = function AIModeButton(_ref) {
  var aiModePromptLabel = _ref.aiModePromptLabel,
    aiModeQuery = _ref.aiModeQuery,
    cloudId = _ref.cloudId,
    onButtonClick = _ref.onClick;
  var _useCloudIdToUrl = useCloudIdToUrl(cloudId || ''),
    data = _useCloudIdToUrl.data;
  var onClickCallback = useCallback(function () {
    onButtonClick();
  }, [onButtonClick]);
  return /*#__PURE__*/React.createElement(Anchor, {
    href: "".concat(data, "/wiki/ai-search/?aiSearchQuery=").concat(aiModeQuery),
    onClick: onClickCallback
  }, /*#__PURE__*/React.createElement(Button, {
    iconBefore: AIModeIcon
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.aiModePromptLabelStyles
  }, aiModePromptLabel)));
};